import type { HelpFile } from '../../types/help'
import { CertificationReviewsTestIds } from '../../../testids/CertificationReviewsTestIds'

export const certificationReviewsHelp: HelpFile = {
  docPage: '/docs/governance/certification-reviews',
  texts: {
    [CertificationReviewsTestIds.reviewMasterDetail]:
      'Access items assigned to you for review — decide to keep or revoke each assignment.',
    [CertificationReviewsTestIds.reviewLeftPanel]: null,
    [CertificationReviewsTestIds.reviewRightPanel]: null,
    [CertificationReviewsTestIds.reviewItemsCount]: null,
    [CertificationReviewsTestIds.reviewProgress]:
      'Review items decided versus total pending in the current queue.',
    [CertificationReviewsTestIds.statDecided]: null,
    [CertificationReviewsTestIds.campaignQuickFilter]:
      'Narrow the review queue to a specific certification campaign.',
    [CertificationReviewsTestIds.colExpand]: null,
    [CertificationReviewsTestIds.colIdentity]: null,
    [CertificationReviewsTestIds.colStatus]: null,
    [CertificationReviewsTestIds.colDecidedAssignments]:
      'Assignments already decided for this identity within the campaign.',
    [CertificationReviewsTestIds.btnBulkCertify]:
      'Certify all selected review items at once — confirm access remains valid for all.',
    [CertificationReviewsTestIds.btnCertifyItem]: null,
    [CertificationReviewsTestIds.btnReassignItem]: null,
    [CertificationReviewsTestIds.btnReviewAssignments]:
      'Open the assignment review screen for the selected identity.',
    [CertificationReviewsTestIds.reviewDetailName]: null,
    [CertificationReviewsTestIds.reviewDetailReviewer]:
      'The reviewer responsible for deciding on this access — usually the identity\'s manager or a delegated certifier.',
    [CertificationReviewsTestIds.reviewDetailCampaign]:
      'The certification campaign this review item belongs to.',
  },
}
